import React from 'react';
import { getCrisilformFields } from '../utilities/form-utilities';
import APIManager from '../../../utilities/api-manager';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));

const getCrisilSubmissionBody = (
    productName: string,
    data: RequestATrialState,
) => {
    const body: RATCrisilRequest = {
        formid: 'marketplaceapi',
        'first-name': data.FirstName,
        'last-name': data.LastName,
        country: data.Country as string,
        state: data.State as string,
        city: data.City,
        email: data.Email,
        'mobile-number': data.Phone,
        comname: data.Company,
        comtype: data.CompanyType as string,
        job: data.JobFunction as string,
        productname: productName,
        comments: data.OtherInterest
    };
    return body;
};

const submitForm = (
    requestBody: RATCrisilRequest,
    cb: () => void,
    error: (error: string) => void
) => {

    APIManager.submitLeadToCrisil(requestBody).then(response => {
        if (response.data) {
            cb();
            return;
        }
        error('Marketo request  failed');
    }).catch(() => error('Marketo request  failed'));
};

function RequestTrialCrisil(props: RequestATrialFormProps) {
    const { productName = '', productVariant, titleText, ratVariant } = props;
    const onSubmit = (
        data: RequestATrialState,
        cb: () => void,
        error: (error: string) => void
    ) => {
        const requestBody = getCrisilSubmissionBody(productName, data);
        submitForm(requestBody, cb, error);

    };
    return (
        <RequestTrialForm onSubmitForm={onSubmit} formTextFields={getCrisilformFields()} productVariant={productVariant} titleText={titleText} ratVariant={ratVariant} />
    );
}

export default React.memo(RequestTrialCrisil);
